export default __webpack_public_path__ + "static/media/sequence.e64eb100.svg";